<template>
    <div>
        <div class="email-notice-bg mb-4 mt-1 bg-white px-3 border" v-if="nositem && item.stock.net <=0 && getVarSelect">
            <form id="sendNoticeForm">
                <p class="bold">
                    Möchtest du benachrichtigt werden wenn der Artikel wieder auf Lager ist ?
                </p>
                <p>
                    <div class="input-unit">
                        <input type="email" name="email" v-model="email" data-autofocus="" id="emailForNote" required>
                        <label for="emailForNote">E-Mail*</label>
                    </div>
                </p>
                <hr>
                <button class="btn btn-primary btn-small btn-block send-notification" @click="sendEmail($event)">
                    Benachrichtigung anfordern
                </button>
            </form>
        </div>
    </div>
</template>

<script>

    export default
    {
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        data: function()
        {
            return {
                findTag:7,
                foundTag:false,
                email:''
            }
        },
        methods:
            {
                sendEmail:function()
                {
                    event.preventDefault();

                    var path = '/stockmsg/entry/create/';
                    var data =
                    {
                        "variationId" : ceresStore.getters.currentItemVariation.variation.id,
                        "itemId"      : ceresStore.getters.currentItemVariation.item.id,
                        "customerMail": this.email
                    }

                    if(ceresStore.state.user.userData != null)
                    {
                        data.customerId = ceresStore.state.user.userData.id;
                    }
                    else
                    {
                        data.customerId = 0;
                    }
                    $.ajax(
                {
                        type: 'POST',
                        url: path,
                        data: data,
                        success: function (response)
                        {
                            response = JSON.parse(response);
                            if(response.allreadyExists==true)
                            {
                                CeresNotification.error('Du lässt dich bereits für diesen Artikel erinnern').closeAfter(3000);
                            }
                            else
                            {
                                CeresNotification.success('Vielen Dank. Wir senden eine Nachricht, wenn der Artikel wieder verfügbar ist.').closeAfter(3000);
                            }
                        },
                        error: function(response)
                        {
                            console.log(response);
                            CeresNotification.error('Irgendwas ist schief gelaufen :/').closeAfter(3000);
                        }
                    });
                },
                getnos:function()
                {
                  let isNos = false;
                  let _self = this;
                  if(this.currentVariation().hasOwnProperty('tags'))
                  {
                    let tags  = this.currentVariation().tags;
                    for(let i = 0; i < tags.length; i++)
                    {
                        if(tags[i].id === _self.findTag)
                        {
                            isNos = true;
                        }
                    }
                  }
                  return isNos;
                },
                currentVariation: function()
                {
                    return this.$store.getters[`${this.itemId}/currentItemVariation`];
                },
                varSelected: function()
                {
                    return this.$store.state.items[`${this.itemId}`].variationSelect.isVariationSelected
                }
            },
        computed:
            {

                item: function()
                {
                    return this.currentVariation();
                },
                nositem:function()
                {
                    return this.getnos()
                },
                getVarSelect:function()
                {
                    return this.varSelected();
                }


            }
    }
</script>
